import { createContext, useContext, useState, useCallback, useRef } from "react";
import type { ReactNode } from "react";

interface TourRunningContextValue {
  isTourRunning: boolean;
  setTourRunning: (running: boolean) => void;
  registerStop: (fn: () => void) => void;
  stopTour: () => void;
}

const TourRunningContext = createContext<TourRunningContextValue>({
  isTourRunning: false,
  setTourRunning: () => {},
  registerStop: () => {},
  stopTour: () => {},
});

export function TourRunningProvider({ children }: { children: ReactNode }) {
  const [isTourRunning, setTourRunning] = useState(false);
  const stopFnRef = useRef<(() => void) | null>(null);

  const registerStop = useCallback((fn: () => void) => {
    stopFnRef.current = fn;
  }, []);

  const stopTour = useCallback(() => {
    stopFnRef.current?.();
  }, []);

  return (
    <TourRunningContext.Provider value={{ isTourRunning, setTourRunning, registerStop, stopTour }}>
      {children}
    </TourRunningContext.Provider>
  );
}

export function useTourRunning() {
  return useContext(TourRunningContext);
}
